export class GenerateCode {
  constructor(
    public lockSerialNumber: string = '',
    public codeType: string = '',
    public lockUserId: number = null,
    public lockUserGroup: string = ''
  ) { }
}
